import React from 'react';
import BookmarkAltIcon from '@heroicons/react/outline/BookmarkAltIcon.js';
import { BlockType } from '../../types/index.js';
import { QuickLinksBlock as Component } from './Block.js';
import { defaultQuickLinksItemsFactory } from './constants.js';
import { QuickLinksBlockSettings as Settings } from './Settings.js';
export const RegisteredQuickLinksBlock = (intl) => {
    const { $t } = intl;
    const defaultQuickLinksItems = defaultQuickLinksItemsFactory(intl);
    return {
        recommendedName: 'QuickLinks',
        Component,
        config: {
            type: BlockType.Block,
            usable: false,
            displayName: $t({
                id: 'Blocks.QuickLinks.DisplayName',
                defaultMessage: 'Quick links',
            }),
            Settings,
            Icon: React.createElement(BookmarkAltIcon, null),
            defaultProps: {
                alignment: 'left',
                actionType: 'link',
                horizontalScroll: true,
                gridCols: 2,
                items: defaultQuickLinksItems,
            },
        },
    };
};
//# sourceMappingURL=registered.js.map